/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1CampaignEvent } from '../models/V1CampaignEvent';
import { HttpFile } from '../http/http';

/**
* ListCampaignEventsResponse is the request to get a campaign Events
*/
export class V1ListCampaignEventsResponse {
    /**
    * List of campaign events
    */
    'campaignEvents'?: Array<V1CampaignEvent>;
    /**
    * A token, which can be sent as `page_token` to retrieve the next page. If this field is omitted, there are no subsequent pages.
    */
    'nextPageToken'?: string;
    /**
    * Number of items in the collection. If filtering is used, the total_size reflects the size of the collection after the filter is applied.
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "campaignEvents",
            "baseName": "campaign_events",
            "type": "Array<V1CampaignEvent>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1ListCampaignEventsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

